import { User, Landmark } from "lucide-react";
import { Input } from "@/components/ui/input";

export const emptyContacto = { nombre: "", rut: "", email: "", telefono: "" };
export const emptyBanco = { nombre: "", rut: "", banco: "", tipo_cuenta: "" };
export const hasAny = (o) => o && Object.values(o).some((v) => (v || "").toString().trim());
export const BANCOS = [
  "Banco de Chile", "BancoEstado", "Santander", "BCI", "Scotiabank", "Itaú",
  "Banco Falabella", "Banco Security", "Banco BICE", "Banco Ripley",
  "Banco Consorcio", "Coopeuch", "Tenpo", "MACH", "Otro",
];

export const ContactBankFields = ({ contacto, banco, datos_bancarios, onContacto, onBanco, onChangeContacto, onChangeBanco }) => {
  const c = contacto || emptyContacto;
  const b = banco || datos_bancarios || emptyBanco;
  const setContacto = onContacto || onChangeContacto || (() => {});
  const setBanco = onBanco || onChangeBanco || (() => {});
  return (
  <>
    <div className="mt-4 rounded-xl bg-gray-50 p-4">
      <p className="mb-3 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-gray-500"><User className="h-3.5 w-3.5" /> Datos de contacto</p>
      <div className="grid gap-3 sm:grid-cols-2">
        <Input data-testid="aff-contacto-nombre" placeholder="Nombre" value={c.nombre || ""} onChange={(e) => setContacto({ ...c, nombre: e.target.value })} className="h-10 border-gray-300" />
        <Input data-testid="aff-contacto-rut" placeholder="RUT" value={c.rut || ""} onChange={(e) => setContacto({ ...c, rut: e.target.value })} className="h-10 border-gray-300" />
        <Input data-testid="aff-contacto-email" type="email" placeholder="Email" value={c.email || ""} onChange={(e) => setContacto({ ...c, email: e.target.value })} className="h-10 border-gray-300" />
        <Input data-testid="aff-contacto-telefono" placeholder="Teléfono" value={c.telefono || ""} onChange={(e) => setContacto({ ...c, telefono: e.target.value })} className="h-10 border-gray-300" />
      </div>
    </div>
    <div className="mt-3 rounded-xl bg-gray-50 p-4">
      <p className="mb-3 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-gray-500"><Landmark className="h-3.5 w-3.5" /> Datos bancarios para pago</p>
      <div className="grid gap-3 sm:grid-cols-2">
        <Input data-testid="aff-banco-nombre" placeholder="Nombre del titular" value={b.nombre || ""} onChange={(e) => setBanco({ ...b, nombre: e.target.value })} className="h-10 border-gray-300" />
        <Input data-testid="aff-banco-rut" placeholder="RUT del titular" value={b.rut || ""} onChange={(e) => setBanco({ ...b, rut: e.target.value })} className="h-10 border-gray-300" />
        <select data-testid="aff-banco-banco" value={b.banco || ""} onChange={(e) => setBanco({ ...b, banco: e.target.value })} className="h-10 rounded-md border border-gray-300 bg-white px-3 text-sm text-brand-ink focus:outline-none focus:ring-1 focus:ring-brand-blue">
          <option value="">Banco…</option>
          {BANCOS.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
        <select data-testid="aff-banco-tipo" value={b.tipo_cuenta || ""} onChange={(e) => setBanco({ ...b, tipo_cuenta: e.target.value })} className="h-10 rounded-md border border-gray-300 bg-white px-3 text-sm text-brand-ink focus:outline-none focus:ring-1 focus:ring-brand-blue">
          <option value="">Tipo de cuenta…</option>
          <option value="Vista">Cuenta Vista</option>
          <option value="Corriente">Cuenta Corriente</option>
          <option value="Ahorro">Cuenta de Ahorro</option>
        </select>
      </div>
    </div>
  </>
  );
};
